import api from './api';

const projectService = {
  getAll: async (params = {}) => {
    const response = await api.get('/projects', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/projects/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/projects', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/projects/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/projects/${id}`);
    return response.data;
  },

  restore: async (id) => {
    const response = await api.post(`/projects/${id}/restore`);
    return response.data;
  },

  // Projektarchiv: soft-gelöschte Projekte des Mandanten
  getArchived: async (params = {}) => {
    const response = await api.get('/projects', { params: { ...params, archived: true } });
    return response.data;
  },

  getByStatus: async () => {
    const response = await api.get('/projects/by-status');
    return response.data;
  },

  getTasks: async (id) => {
    const response = await api.get(`/projects/${id}/tasks`);
    return response.data;
  },

  getBacklinks: async (id) => {
    const response = await api.get(`/projects/${id}/backlinks`);
    return response.data;
  },

  getBudget: async (id) => {
    const response = await api.get(`/projects/${id}/budget`);
    return response.data;
  },

  // Adressverwaltung
  getAddresses: async (id) => {
    const response = await api.get(`/projects/${id}/addresses`);
    return response.data;
  },

  addAddress: async (projectId, addressId, data = null) => {
    const response = await api.post(`/projects/${projectId}/addresses/${addressId}`, data);
    return response.data;
  },

  removeAddress: async (projectId, addressId, contactPersonId = null) => {
    const url = contactPersonId 
      ? `/projects/${projectId}/addresses/${addressId}?contact_person_id=${contactPersonId}`
      : `/projects/${projectId}/addresses/${addressId}`;
    const response = await api.delete(url);
    return response.data;
  },

  // Kategorien
  getCategories: async () => {
    const response = await api.get('/projects/meta/categories');
    return response.data;
  },

  // Tags
  getTags: async () => {
    const response = await api.get('/projects/meta/tags');
    return response.data;
  },

  // Beteiligungsart aktualisieren
  updateParticipationType: async (projectId, addressId, data) => {
    const response = await api.patch(`/projects/${projectId}/addresses/${addressId}/participation`, data);
    return response.data;
  },
};

export default projectService;
